import { http } from "../helpers/easyindustriaapi/config";

export default class AccountsReceivable {
    constructor(user = null, empresa = null) {
        this.http = http;
        this.user = user;
        this.empresa = empresa;
    }

    async getAccountsReceivable(empresaId = this.empresa.id, params = null) {
        let url = `/contas-a-receber?empresa_id=${empresaId}`
        
        if (params) {
            const queryParams = new URLSearchParams()
            
            if (params.vencimento_ini) queryParams.append('vencimento_ini', params.vencimento_ini)
            if (params.vencimento_end) queryParams.append('vencimento_end', params.vencimento_end)
            if (params.data_pagamento_ini) queryParams.append('data_pagamento_ini', params.data_pagamento_ini)
            if (params.data_pagamento_end) queryParams.append('data_pagamento_end', params.data_pagamento_end)
            if (params.status !== null && params.status !== undefined) queryParams.append('status', params.status)
            if (params.numero_documento) queryParams.append('numero_documento', params.numero_documento)
            if (params.descricao) queryParams.append('descricao', params.descricao)
            if (params.ano_competencia) queryParams.append('ano_competencia', params.ano_competencia)
            if (params.mes_competencia) queryParams.append('mes_competencia', params.mes_competencia)
            
            const queryString = queryParams.toString()
            if (queryString) {
                url += `&${queryString}`
            }
        }
        
        const response = await this.http.get(url)
        return response.data
    }

    async createAccountReceivable(conta, empresaId = this.empresa.id) {
        const payload = { ...conta, empresa_id: empresaId }
        const response = await this.http.post(`/contas-a-receber?empresa_id=${empresaId}`, payload)
        return response.data
    }

    async receiveAccount({ id, data_recebimento, conta_credito_id }, empresaId = this.empresa.id) {
        const payload = { id, data_recebimento, conta_credito_id, empresa_id: empresaId }
        const response = await this.http.put(`/contas-a-receber/receber?empresa_id=${empresaId}`, payload)
        return response.data
    }

    async partialReceiveAccount({ id, valor_recebido, data_recebimento, conta_credito_id, observacao = null }, empresaId = this.empresa.id) {
        const payload = {
            id,
            valor_recebido,
            data_recebimento,
            conta_credito_id,
            observacao,
            empresa_id: empresaId
        }
        const response = await this.http.post(`/contas-a-receber/${id}/recebimentos?empresa_id=${empresaId}`, payload)
        return response.data
    }

    async deleteAccountReceivable(contaReceber, empresaId = this.empresa.id) {
        try {
            const response = await this.http.delete(`/contas-a-receber/${contaReceber.id}?empresa_id=${empresaId}`, contaReceber);
            return {
                success: true,
                data: response.data,
                status: response.status
            };
        } catch (error) {
            return {
                success: false,
                error: error.response || error,
                status: error.response?.status || 500,
                message: error.response?.data?.message || 'Erro ao excluir conta a receber'
            };
        }
    }
}

